/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetBracketsMatchesMatchidReplayMetricsQueryResponse,
  GetBracketsMatchesMatchidReplayMetricsPathParams,
} from "../types/GetBracketsMatchesMatchidReplayMetrics.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getBracketsMatchesMatchidReplayMetricsQueryKey = (
  matchId:
    GetBracketsMatchesMatchidReplayMetricsPathParams["matchId"] | undefined,
) =>
  [
    {
      url: "/brackets/matches/:matchId/replay-metrics",
      params: { matchId: matchId },
    },
  ] as const;

export type GetBracketsMatchesMatchidReplayMetricsQueryKey = ReturnType<
  typeof getBracketsMatchesMatchidReplayMetricsQueryKey
>;

/**
 * @summary Метрики по матчу: строка на участника КАЖДОЙ игры. Для серии (Bo3/Bo5) игры не
 * усредняются — разбор матча показывает их по отдельности.
 * Перцентилей здесь нет: сравнивать игрока не с кем, группа сравнения — турнир.
 * {@link /brackets/matches/:matchId/replay-metrics}
 */
export async function getBracketsMatchesMatchidReplayMetrics(
  matchId: GetBracketsMatchesMatchidReplayMetricsPathParams["matchId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetBracketsMatchesMatchidReplayMetricsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/brackets/matches/${matchId}/replay-metrics`,
    ...requestConfig,
  });
  return res;
}

export function getBracketsMatchesMatchidReplayMetricsQueryOptions(
  matchId:
    GetBracketsMatchesMatchidReplayMetricsPathParams["matchId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getBracketsMatchesMatchidReplayMetricsQueryKey(matchId);
  return queryOptions<
    ResponseConfig<GetBracketsMatchesMatchidReplayMetricsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetBracketsMatchesMatchidReplayMetricsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!matchId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getBracketsMatchesMatchidReplayMetrics(matchId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Метрики по матчу: строка на участника КАЖДОЙ игры. Для серии (Bo3/Bo5) игры не
 * усредняются — разбор матча показывает их по отдельности.
 * Перцентилей здесь нет: сравнивать игрока не с кем, группа сравнения — турнир.
 * {@link /brackets/matches/:matchId/replay-metrics}
 */
export function useGetBracketsMatchesMatchidReplayMetrics<
  TData = ResponseConfig<GetBracketsMatchesMatchidReplayMetricsQueryResponse>,
  TQueryData =
    ResponseConfig<GetBracketsMatchesMatchidReplayMetricsQueryResponse>,
  TQueryKey extends QueryKey = GetBracketsMatchesMatchidReplayMetricsQueryKey,
>(
  matchId:
    GetBracketsMatchesMatchidReplayMetricsPathParams["matchId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetBracketsMatchesMatchidReplayMetricsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getBracketsMatchesMatchidReplayMetricsQueryKey(matchId);

  const query = useQuery(
    {
      ...getBracketsMatchesMatchidReplayMetricsQueryOptions(matchId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
